import React, {useState, useEffect} from 'react';
import moment from 'moment-timezone';

const Countdown = () => {
  const [countdown, setCountdown] = useState('');
  let interval; // Declare interval variable outside useEffect
  const [isHoliday, setIsHoliday] = useState(false);

  useEffect(() => {
    const updateCountdown = () => {
      const now = moment.tz("America/New_York");
      const targetTime = moment.tz("America/New_York").set({hour: 8, minute: 30, second: 0});
      const endTime = moment.tz("America/New_York").set({hour: 16, minute: 0, second: 0});
      const weekDay = now.day();
      weekDay === 0 || weekDay === 6 ? setIsHoliday(true) : setIsHoliday(false);

      // If it's past 8:30 AM but before 4:00 PM, stop the countdown
      if (now.isAfter(targetTime) && now.isBefore(endTime)) {
        setCountdown('Trading is open.');
        clearInterval(interval); // Clear the interval
        return;
      }

      // If it's past 4:00 PM, set the target time to 8:30 AM next day
      if (now.isAfter(endTime)) {
        targetTime.add(1, 'days');
      }

      const diff = moment.duration(targetTime.diff(now));
      const hours = diff.hours();
      const minutes = diff.minutes();
      const seconds = diff.seconds();

      setCountdown(`${hours}h ${minutes}m ${seconds}s`);
    };

    updateCountdown(); // Call once immediately

    interval = setInterval(updateCountdown, 1000); // Update every second

    return () => clearInterval(interval); // Cleanup
  }, []);

  return (
    <div>
      {isHoliday ?
        <h3>Today is a holiday. Trading is closed.</h3>
      :
      <div>
        <h3>Please come back in:</h3>
        <h2>{countdown}</h2>
        <p>(8:30 AM New York time)</p>
      </div>
      }
    </div>
  );
};

export default Countdown;
